import { QueryClient } from "@tanstack/react-query";

/**
 * The app's single QueryClient.
 *
 * Lives here rather than in `root.tsx` so that code outside the React tree can reach it —
 * notably `clearSession`, which runs both from a component and from a route loader and has
 * to empty this cache. Importing `root.tsx` for it would pull the whole app in behind it.
 */
export const queryClient = new QueryClient();
